import React, { createContext, useCallback, useContext } from 'react';
import api from '../services/api';

const StorageContext = createContext({});

const StorageProvider = ({ children }) => {
  const uploadFile = useCallback(async ({ file }) => {
    const token = localStorage.getItem('@Braspress:token');

    const formData = new FormData();

    formData.append('File', file);

    const response = await api.post(
      `${process.env.REACT_APP_URL_MS_STORAGE}/storage`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data'
        }
      }
    );

    const { url } = response.data.data;

    return url;
  }, []);

  const contextValues = { uploadFile };

  return (
    <StorageContext.Provider value={contextValues}>
      {children}
    </StorageContext.Provider>
  );
};

function useStorage() {
  const context = useContext(StorageContext);

  if (!context) {
    throw new Error('useStorage must be used within an StorageProvider');
  }

  return context;
}

export { StorageProvider, useStorage };
